export interface HabitArchiveItem {
  id: string
}

export function removeHabitById<T extends HabitArchiveItem>(
  habits: T[],
  habitId: string,
): T[] {
  return habits.filter((habit) => habit.id !== habitId)
}
